'use strict';

const { h } = require('phy');

const { WithI18n } = require('@grpn/preact-l10n');
const { parse, valueIsNotNull } = require('../../support/localisation-parser');

function getRichTextInner({
  className = '',
  sectionHeadingKey = '',
  richTextKey,
}) {
  return h(WithI18n, {}, i18n =>
    h(
      '.row',
      h(
        '.twelve.columns',
        h(`section.richtext.${className}`, [
          valueIsNotNull(i18n.t(sectionHeadingKey)) &&
            h('h3', i18n.t(sectionHeadingKey)),
          h('.richtext-inner', {
            dangerouslySetInnerHTML: {
              __html: parse(i18n.t(richTextKey)),
            },
          }),
        ])
      )
    )
  );
}

function RichText({
  className = '',
  display,
  richTextKey,
  sectionHeadingKey,
  hasContrast = false,
}) {
  if (!display) {
    return null;
  }

  const RichTextInner = getRichTextInner({
    className,
    sectionHeadingKey,
    richTextKey,
  });

  return h(
    WithI18n,
    {},
    i18n =>
      valueIsNotNull(i18n.t(richTextKey)) &&
      (hasContrast
        ? h('.row-contrast', h('.page-container', RichTextInner))
        : RichTextInner)
  );
}

module.exports = RichText;
